import React from "react";
import TextBlockEditor from "../shared/blocks/TextBlockEditor";
import HeadingBlockEditor from "../shared/blocks/HeadingBlockEditor";
import ImageBlockEditor from "../shared/blocks/ImageBlockEditor";
import CodeBlockEditor from "../shared/blocks/CodeBlockEditor";
import CodeWebBlockEditor from "../shared/blocks/CodeWebBlockEditor";
import SingleChoiceBlockEditor from "./SingleChoiceBlockEditor";
import MultipleChoiceBlockEditor from "./MultipleChoiceBlockEditor";
import PlaceholderCodeEditor from "./PlaceholderCodeEditor";
import ListBlockEditor from "../shared/blocks/ListBlockEditor";
import InfoBlockEditor from "../shared/blocks/InfoBlockEditor";
import WarningBlockEditor from "../shared/blocks/WarningBlockEditor";
import CodeFillEditor from "./CodeFillCodeEditor";

export default function LessonBlockEditorPanel({
                                             fragmentId,
                                             block,
                                             onChange,
                                             courseId,
                                         }) {

    if (!fragmentId) {
        return (
            <div className="text-gray-500">
                یک فرگمنت انتخاب کن
            </div>
        );
    }

    if (!block) {
        return (
            <div className="text-gray-500">
                یک بلاک انتخاب کن
            </div>
        );
    }

    const set = (patch) => onChange(patch);

    switch (block.type) {

        case "text":
            return <TextBlockEditor block={block} onChange={set} />;

        case "heading":
            return <HeadingBlockEditor block={block} onChange={set} />;

        case "image":
            return (
                <ImageBlockEditor
                    block={block}
                    onChange={set}
                    courseId={courseId}
                />
            );

        case "list":
            return (
                <ListBlockEditor
                    block={block}
                    onChange={set}
                />
            );

        case "info":
            return (
                <InfoBlockEditor
                    block={block}
                    type="دانستنی"
                    onChange={set}
                />
            );

        case "warning":
            return (
                <WarningBlockEditor
                    block={block}
                    type="هشدار"
                    onChange={set}
                />
            );

        case "code":
            return (
                <CodeBlockEditor
                    block={block}
                    onChange={set}
                />
            );

        case "code_web":
            return (
                <CodeWebBlockEditor
                    block={block}
                    onChange={set}
                />
            );

        case "question_single_choice":
            return (
                <SingleChoiceBlockEditor
                    block={block}
                    onChange={set}
                    courseId={courseId}
                />
            );

        case "question_multiple_choice":
            return (
                <MultipleChoiceBlockEditor
                    block={block}
                    onChange={set}
                    courseId={courseId}
                />
            );

        case "placeholder_code":
            return (
                <PlaceholderCodeEditor
                    block={block}
                    onChange={set}
                    courseId={courseId}
                />
            );

        case "code_fill":
            return (
                <CodeFillEditor
                    block={block}
                    onChange={set}
                    courseId={courseId}
                />
            );

        default:
            return (
                <div className="text-red-500">
                    Unsupported block type: {block.type}
                </div>
            );
    }
}